export class Email {
  private email: string;

  constructor(email: string) {
    this.email = email;
  }

  isValid(): boolean {
    // Define a regular expression for validating an email address
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(this.email);
  }

  toString(): string {
    return this.email;
  }

  getErrorTest() {
    return "Invalid email address.";
  }
}
